<template>
  <div class="left content_daily">
    <div class="head">您好，{{ isToday ? `今日（截止${hour}点）` : '昨日' }}药品监管数据如下，请及时跟进处理：</div>
    <div v-for="(item, key) in list" :key="key" class="content">
      <div class="title left" v-if="item.messageDataType == 5">
        库存统计
        <el-button type="text" @click="handleNavigateStore()">（查看详情）</el-button>
      </div>
      <div class="title left" v-else-if="item.messageDataType == 9">
        风险处方（互联网医院诊疗风险药品）
        <el-button type="text" @click="handleNavigateAlarm()">（查看详情）</el-button>
      </div>
      <div class="title left" v-else>
        {{ type[item.classify] }}
        <el-button type="text" @click="handleNavigate(item.classify, msgType)">（查看详情）</el-button>
      </div>
      <!-- 主动登记消息体 青神登记 -->
      <div v-if="(msgType == 3 || msgType == 10) && isDrug(item)">
        <div v-if="item.classify == 3">
          处方药品共
          <span class="num color1">{{ item.registrationNum || 0 }}</span>
          条；
        </div>
        <div v-else>
          登记记录共
          <span class="num color1">{{ item.registrationNum || 0 }}</span>
          条，
          <span class="num color2">{{ item.normalRegistrationNum || 0 }}</span>
          条正常，
          <span class="num color3">{{ item.anomalyRegistrationNum || 0 }}</span>
          条异常；
        </div>
      </div>
      <!-- 匹配登记体 九龙坡旧 暂不废弃-->
      <div v-if="msgType == 99 && isDrug(item)">
        <div>
          销售订单共
          <span class="num color1">{{ item.orderNum || 0 }}</span>
          单，
          <span class="num color2">{{ item.registeredOrderNum || 0 }}</span>
          单已登记，
          <template v-if="isToday">
            <span class="num color3">{{ item.toRegisteredOrderNum || 0 }}</span>
            单待登记；
          </template>
          <template v-else>
            <span class="num color3">{{ item.unRegisteredOrderNum || 0 }}</span>
            单未登记；
          </template>
        </div>
      </div>
      <!-- 药品维度展示 -->
      <template v-if="msgType == 6">
        <drug-msg-content :item="item" :isToday="isToday" v-if="isDrug(item)" />
      </template>
      <!-- 风险处方药品 -->
      <template v-if="item.messageDataType == 9">
        <div>
          风险处方药品数量
          <span class="num color3">{{ item.riskDrugNum || 0 }}</span>
          条
        </div>
      </template>
      <!-- // 库存统计 -->
      <template v-if="item.messageDataType == 5">
        <div>
          近效期药品数量
          <span class="num color4">{{ item.closeExpiredDrugNum || 0 }}</span>
          条，过期药品数量
          <span class="num color3">{{ item.expiredDrugNum || 0 }}</span>
          条；
        </div>
      </template>
    </div>
    <!-- <div class="bottom left">。</div> -->
  </div>
</template>

<script>
import dayjs from 'dayjs';

import drugMsgContent from './drugMsgContent.vue';
export default {
  components: {
    drugMsgContent
  },
  props: ['msgType', 'messageTime', 'list'],
  data() {
    return {
      type: {
        1: '四类药品',
        2: '特殊药品',
        3: '处方药品'
      }
    };
  },
  computed: {
    isToday() {
      return dayjs(this.messageTime).isSame(dayjs(), 'day');
    },
    hour() {
      return dayjs(this.messageTime).hour();
    }
  },
  methods: {
    isDrug(item = {}) {
      return item.classify == 1 || item.classify == 2 || item.classify == 3;
    },
    async handleNavigate(type, msgType) {
      this.$emit('handleNavigate', type, msgType);
    },
    handleNavigateStore() {
      this.$emit('handleNavigateStore');
    },
    handleNavigateAlarm() {
      this.$emit('handleNavigateAlarm');
    }
  }
};
</script>
<style lang="scss" scoped>
.content_daily {
  max-height: 70vh;
  overflow-y: auto;
}
.head {
  font-size: 14px;
  margin-bottom: 24px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.content {
  color: #333;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 12px;
  // text-align: left;
}
.box-content {
  display: flex;
  max-width: 390px;
}
.box-item {
  min-width: 70px;
}
.num {
  font-weight: 600;
}
.color1 {
  color: #262626;
}
.color2 {
  color: #1e8dff;
}
.color3 {
  color: #ff4e47;
}
.left {
  text-align: left;
}
.color4 {
  color: #ff8200;
}
</style>
